import { useMutation } from 'react-query';

import { updateMFAPin } from '../../lib/api';

export function useMutateSetupRevokePin() {
  return useMutation(updateMFAPin);
}
